module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("课题组信息")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.researchGroupDetail) ? _c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.researchGroupDetail), function(info, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_attr"
    }, [_c('div', {
      staticClass: "group"
    }, [_c('span', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(info.name))]), _vm._v(" "), _c('span', {
      staticClass: "attr"
    }, [_vm._v(_vm._s(info.value))])]), _vm._v(" "), _vm._m(0, true)])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vw"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-958dfe2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupManagement/ResearchGroupDetail.vue
// module id = 1696
// module chunks = 8